import { render, staticRenderFns } from "./Statement-report.vue?vue&type=template&id=52a801f2"
import script from "./Statement-report.vue?vue&type=script&lang=js"
export * from "./Statement-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports